import { render, staticRenderFns } from "./ResetPwd.vue?vue&type=template&id=9f5fb422&"
import script from "./ResetPwd.vue?vue&type=script&lang=js&"
export * from "./ResetPwd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('9f5fb422', component.options)
    } else {
      api.reload('9f5fb422', component.options)
    }
    module.hot.accept("./ResetPwd.vue?vue&type=template&id=9f5fb422&", function () {
      api.rerender('9f5fb422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pages/Login/ResetPwd.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Pages/Login/ResetPwd.vue
// module id = k68P
// module chunks = 0